import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {CheckoutError} from "../../checkout/Checkout";
import {useCheckoutContext} from "../../checkout/CheckoutContextProvider/CheckoutContextProvider";
import {useCheckoutViewContext} from "../../checkout/CheckoutContextProvider/CheckoutViewContextProvider";
import {Button, ButtonStyles, ButtonType} from "../form/Button/Button";
import window from "../WindowExtended";
import {amazonPayWalletContainerId, cancelAmazonPay, widgetOptions} from "./AmazonPayLibrary";
import CartDetails from "../../cart/CartDetails/CartDetails";
import Spinner from "../../utils/loader/Spinner";

const AmazonPayWalletWidget: React.FC<{
  errors: (string | JSX.Element)[];
  onError: (errorString: string) => void;
}> = (props) => {
  const {checkout} = useCheckoutContext();
  const {gotoStep} = useCheckoutViewContext();
  const {t} = useTranslation("checkout");
  const [isPaymentSet, setIsPaymentSet] = useState<boolean>(false);

  useEffect(() => {
    if (!window.amazon) {
      return;
    }

    new window.OffAmazonPayments.Widgets.Wallet({
      amazonOrderReferenceId: window.orderReferenceId,
      onError: (err) => props.onError(`[AmazonPayWallet] ${err.getErrorCode()}: ${err.getErrorMessage()}`),
      onPaymentSelect: () => {
        window.isBillingAgreementPaymentSet = true;
        window.isPreauthorizingDone = false;
        setIsPaymentSet(true);
      },
      ...widgetOptions,
    })
      .setPresentmentCurrency(window.c_ActiveCurrency)
      .bind(amazonPayWalletContainerId);
  }, []);

  const continueCheckout = () => {
    gotoStep();
  };

  const cancel = () => {
    cancelAmazonPay();
    void checkout.put({paymentId: null});
  };

  return (
    <div className="reduced-width">
      <CheckoutError>{props.errors}</CheckoutError>
      <div style={{marginBottom: "1rem"}}>
        <div id={amazonPayWalletContainerId} style={{height: "230px", marginBottom: ".5rem"}}>
          {/* Filled by Amazon Pay */}
        </div>
        <span style={{cursor: "pointer", color: "#1ba1e2"}} onClick={cancel}>
          {t("Zahlung mit Amazon Pay abbrechen")}
        </span>
      </div>
      <CartDetails reduced />
      <Button
        styles={[ButtonStyles.wide]}
        action={continueCheckout}
        type={props.errors.length || !isPaymentSet ? ButtonType.disabled : ButtonType.default}
      >
        {isPaymentSet || props.errors.length ? t("Weiter") : <Spinner />}
      </Button>
    </div>
  );
};

export default AmazonPayWalletWidget;
